import { objectToTranslatableChoices } from '@shared/choice';
import { GutterMaterial } from '@shared/types/api/externalDamage';
export const GUTTER_MATERIAL_TRAD_KEYS = {
    [GutterMaterial.Zinc]: 'claim.declaration.external_damages.form.gutter.material.zinc',
    [GutterMaterial.PVC]: 'claim.declaration.external_damages.form.gutter.material.pvc',
    [GutterMaterial.Alumninium]: 'claim.declaration.external_damages.form.gutter.material.alumninium',
};
export const GUTTER_MATERIAL_CHOICES = objectToTranslatableChoices(GUTTER_MATERIAL_TRAD_KEYS);
